import { Tooltip } from '@mui/material'

const DayTooltip = ({
  children,
  title,
  placement = 'auto',
}: {
  children: React.ReactElement
  title: string
  placement?: 'auto' | 'top' | 'bottom' | 'left' | 'right'
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={true}
      enterDelay={400}
    >
      {children}
    </Tooltip>
  )
}

export default DayTooltip
